import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import { updateAttractionName } from '~/services/AttractionsService';

import { attractionQueryKeys } from './attractionQueryKeys';
import { useCanonicalAttractionRedirect } from './useCanonicalAttractionRedirect';

interface UpdateAttractionNameData {
  attractionId: string;
  name: string;
}

export function useUpdateAttractionName() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();
  const { retargetFromMutationError } = useCanonicalAttractionRedirect();

  return useMutation({
    mutationFn: ({ attractionId, name }: UpdateAttractionNameData) => updateAttractionName(attractionId, name),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: attractionQueryKeys.detail(variables.attractionId) });
      queryClient.invalidateQueries({ queryKey: attractionQueryKeys.lists() });
      enqueueSnackbar('Attraction name updated', { variant: 'success' });
    },
    onError: (error: Error, variables) => {
      if (retargetFromMutationError(error, variables.attractionId)) return;
      enqueueSnackbar(`Error updating name: ${error.message || 'Unknown error'}`, { variant: 'error' });
    },
  });
}
